import { AuthUserService } from '../authsettings/services/authusers.service';
import { AuthService } from '../authorization/services';
import { IShift } from '../services/shifts.service';
import * as moment from 'moment';
import { ITeam } from "../services/index";
import env from '../config';

class AppController {
    private user: {};
    private version: string;

    private authorized: boolean;
    private menuItems: any;

    private shifts: IShift[];
    private currentShift: IShift;
    private locations: any;
    private teams: ITeam[];
    private accountNotes: any;
    private employees: any;
    private selectedEmployee: any;

    constructor(
        private AuthService: AuthService,
        private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private ThemeService: aboTheme.IThemeService,
        private AuthUserService: AuthUserService
    ) {
        'ngInject';

        this.menuItems = [
            {'name': 'Dashboard', 'sref': 'dashboard', 'iconclass': 'fa fa-flask', 'role': 'BACKOFFICE'},
            {'name': 'Diensten', 'sref': 'shifts', 'iconclass': 'fa fa-calendar-o', 'role': 'BACKOFFICE'},
            {'name': 'Taken', 'sref': 'tasks', 'iconclass': 'fa fa-tasks', 'role': 'BACKOFFICE', 'submenu': [
                {'name': 'Actieve taken', 'sref': 'tasks.list'},
                {'name': 'Archief', 'sref': 'tasks.archive'},
            ]},
            {'name': 'Urenregistratie', 'sref': 'timesheets', 'iconclass': 'fa fa-clock-o', 'role': 'TIMESHEETS', 'submenu': [
                {'name': 'Doorboeken', 'sref': 'timesheets.dashboard'},
                {'name': 'Overzicht', 'sref': 'timesheets.overview', 'role': 'FINANCE'},
            ]},
            {'name': 'Financieel', 'sref': 'quotations', 'iconclass': 'fa fa-file-text-o', 'role': 'FINANCE', 'submenu': [
                {'name': 'Pro forma facturen', 'sref': 'quotations.proforma'},
                {'name': 'Facturatie', 'sref': 'quotations.dashboard'},
                {'name': 'Cootje', 'sref': 'quotations.cootje'},
            ] },
            {'name': 'CRM', 'sref': 'crm', 'iconclass': 'fa fa-users', 'role': 'BACKOFFICE', 'submenu': [
                {'name': 'Bedrijven', 'sref': 'crm.accounts'},
                {'name': 'Contacten', 'sref': 'crm.contacts'},
            ] },
            {'name': 'HR', 'sref': 'hr', 'iconclass': 'fa fa-user-o', 'role': 'BACKOFFICE', 'submenu': [
                { 'name': 'Medewerkers', 'sref': 'hr.employees' },
                { 'name': 'Beschikbaarheid', 'sref': 'hr.availability' },
            ]},
            {'name': 'Recruitment', 'sref': 'hr.applicants', 'iconclass': 'fa fa-user-o', 'role': 'BACKOFFICE', 'submenu': [
                { 'name': 'Sollicitanten', 'sref': 'hr.applicants.list' },
                { 'name': 'Sollicitanten archief', 'sref': 'hr.applicants.archive' }
            ]},
            {'name': 'Instellingen', 'sref':'questions', 'iconclass': 'fa fa-gear', 'role': 'BACKOFFICE', 'submenu' : [
                {'name': 'Accounts', 'sref': 'authsettings', 'role': 'SUPERUSER' },
                {'name': 'Kantoorpersoneel', 'sref': 'settings.staff', 'role': 'SUPERUSER' },
                {'name': 'Stamdata', 'sref': 'masterdata', 'role': 'BACKOFFICE' },
                {'name': 'Salary scales', 'sref': 'settings.salaryscales', 'role': 'BACKOFFICE' },
                // {'name': 'Email-templates', 'sref': 'settings.templates', 'role': 'SUPERUSER' },
                {'name': 'ORT dagen', 'sref': 'settings.timezones', 'role': 'BACKOFFICE' }
            ] },
            // {'name': 'Dashboard', 'sref': 'dashboard', 'iconclass': 'fa fa-flask', 'role': 'EMPLOYEE'},
            {'name': 'Agenda', 'sref': 'schedule', 'iconclass': 'fa fa-calendar-o', 'role': 'EMPLOYEE'},
            {'name': 'Declaraties', 'sref': 'schedule.declarations', 'iconclass': 'fa fa-clock-o', 'role': 'EMPLOYEE'},
            {'name': 'Inschrijven', 'sref': 'subscriptions', 'iconclass': 'fa fa-list-ul', 'role': 'EMPLOYEE'},
            {'name': 'Vaardigheden', 'sref': 'skills', 'iconclass': 'fa fa-wrench', 'role': 'EMPLOYEE'},
            {'name': 'Documentatie', 'sref': 'documentation', 'iconclass': 'fa fa-book', 'role': 'EMPLOYEE'},
            {'name': 'Diensten', 'sref': 'customerShifts', 'iconclass': 'fa fa-calendar', 'role': 'CUSTOMER'}
        ];

        this.currentShift = new IShift();
        this.currentShift.start = this.roundMinutes(new Date());
        this.currentShift.end = moment(this.currentShift.start).add(8, 'hour').toDate();
    }

    roundMinutes(date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    }

    public $onInit = () => {

        this.version = env.VERSION;

        this.ThemeService.setIsSmallSidebar(false);

        this.AuthUserService.getCurrentUser().then((user) => {
            this.user = user;
        })

        // this.$scope.$on('getAdHocShiftsUp', (event, data) => {
        //     console.log('getAdHocShiftsUp'); 
        //     this.$scope.$broadcast('getAdHocShiftsDown', data);
        // });
    }
}

export const app = {
    controller: AppController,
    template: require('./app.html')
};



// WEBPACK FOOTER //
// ./src/app/main/app.component.ts